import type { PayoutStatus } from '../types';

/**
 * Payout state machine — docs §5.4.
 *
 * Encoded as data so no screen can offer an illegal transition. Any transition not
 * listed here (e.g. `draft → paid`) is a 422 server-side and must never be rendered.
 */
export const PAYOUT_TRANSITIONS: Record<PayoutStatus, PayoutStatus[]> = {
  draft: ['approved', 'cancelled'],
  approved: ['paid', 'cancelled'],
  paid: [],
  cancelled: [],
};

/** Transitions legal from `status`; empty for a terminal payout. */
export const allowedTransitions = (status: PayoutStatus): PayoutStatus[] =>
  PAYOUT_TRANSITIONS[status] ?? [];

/** `reference` is required by the API when moving a payout to `paid`. */
export const requiresReference = (to: PayoutStatus): boolean => to === 'paid';

export const PAYOUT_ACTION_LABELS: Record<PayoutStatus, string> = {
  draft: 'Move to draft',
  approved: 'Approve',
  paid: 'Mark as paid',
  cancelled: 'Cancel',
};

/** Error code returned by `POST /merchant/payouts` when nothing was payable. */
export const NON_POSITIVE_BALANCE_CODE = 'non_positive_payout_balance';
